import React from "react";
import editIcon from "../../../assets/images/edit-dark.svg";
import { calculateDuration } from "../../../utils/helper";
import dayjs from "dayjs";
import { PAID } from "../../../utils/constants";

interface ConditionItemProps {
  label: string;
  value: string | number;
  editable?: boolean;
}

const ConditionItem: React.FC<ConditionItemProps> = ({
  label,
  value,
  editable,
}) => {
  return (
    <div className="flex gap-4 justify-between items-start w-full">
      <div className="flex flex-col flex-1 shrink basis-0 w-full text-left">
        <div className="text-sm leading-loose text-gray-500">{label}</div>
        <div className="mt-1 text-base font-semibold text-gray-800">
          {value}
        </div>
      </div>
      {editable && (
        <img
          loading="lazy"
          src={editIcon}
          className="object-contain shrink-0 w-6 aspect-square"
          alt=""
        />
      )}
    </div>
  );
};

const ConditionSection: React.FC<any> = ({ plan }) => {
  const months = plan?.duration ? Math.floor(plan.duration / 30) : 0;
  const duration =
    plan?.plan_start_date && plan?.plan_end_date
      ? `${dayjs(plan?.plan_start_date).format("DD MMM YYYY")} - ${dayjs(
          plan.plan_end_date
        ).format("DD MMM YYYY")}`
      : "-NA-";

  return (
    <>
      <section className="flex overflow-hidden flex-col items-start p-4 mt-4 w-full bg-white rounded-3xl border border-gray-200 border-solid shadow-sm">
        <ConditionItem label="Condition" value={plan?.medical_condition_name} />
        <ConditionItem
          label={`Plan ${
            plan?.status === PAID ? "purchased by" : "referred to"
          } the Patient`}
          value={plan?.plan_name}
        />
        <ConditionItem
          label="Care Plan Referred on"
          value={dayjs(plan?.created_at).format("DD MMM YYYY") || "-NA-"}
        />
        <ConditionItem
          label={`Care Plan Duration ${months ? `(${months} Months)` : ""}`}
          value={duration}
        />
      </section>
    </>
  );
};

export default ConditionSection;
